import { render, staticRenderFns } from "./userPostController.vue?vue&type=template&id=f8906216&scoped=true&"
import script from "./userPostController.vue?vue&type=script&lang=js&"
export * from "./userPostController.vue?vue&type=script&lang=js&"
import style0 from "./userPostController.vue?vue&type=style&index=0&id=f8906216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8906216",
  null
  
)

export default component.exports